import { gql } from "lib/apolloClient";
import {
  plannerElementSetFragment,
  plannerElementNodeSetFragment,
} from "./PlannerElementDataSetFragments";

export const getCurriculumSubjectGroupsGradesAndTagsQuery = gql`
  query getCurriculumSubjectsGroupsGradesAndTags(
    $orgId: ID!
    $curriculumProgramId: ID!
    $shouldSkipGrades: Boolean = false
    $shouldSkipSubjectGroups: Boolean = false
    $shouldSkipGenericTags: Boolean = false
    $genericTagsFilter: GenericTagsFilter
  ) {
    node(id: $orgId, type: ORGANIZATION) {
      ... on Organization {
        id
        grades(filters: { curriculumProgramIds: [$curriculumProgramId] })
          @skip(if: $shouldSkipGrades) {
          id
          name
        }
        genericTagsV2(filters: $genericTagsFilter)
          @skip(if: $shouldSkipGenericTags) {
          id
          label
        }
        subjectGroups(
          filters: { curriculumProgramIds: [$curriculumProgramId] }
        ) @skip(if: $shouldSkipSubjectGroups) {
          id
          name
        }
      }
    }
  }
`;

export const getPlannerElementSetsOfCurriculumQuery = gql`
  query getPlannerElementSetsOfCurriculum(
    $id: ID!
    $elementTypes: [PLANNER_ELEMENT_TYPE_ENUM]
    $filters: PlannerElementFilters
    $type: ENTITY_TYPE_ENUM!
  ) {
    node(id: $id, type: $type) {
      id
      ... on IbMypCurriculumProgram {
        id
        plannerElementSets(elementTypes: $elementTypes) {
          ...plannerElementSetWithNodesItem
        }
      }
      ... on UBDCurriculumProgram {
        id
        plannerElementSets(elementTypes: $elementTypes) {
          ...plannerElementSetWithNodesItem
        }
      }
      ... on IbDpCurriculumProgram {
        id
        plannerElementSets(elementTypes: $elementTypes) {
          ...plannerElementSetWithNodesItem
        }
      }
    }
  }

  ${plannerElementSetFragment.plannerElementSetWithNodes}
`;

export const getPlannerElementNodeSetQuery = gql`
  query getPlannerElementNodeSet(
    $id: ID!
    $plannerElementNodeFilters: PlannerElementNodeFilters
  ) {
    node(id: $id, type: PLANNER_ELEMENT_NODE_SET) {
      ...plannerElementNodeSetWithNodesItem
    }
  }

  ${plannerElementNodeSetFragment.plannerElementNodeSetWithNodes}
`;

export const getSubjectVariantsQuery = gql`
  query getSubjectVariants($subjectId: ID!) {
    node(id: $subjectId, type: SUBJECT) {
      id
      ... on Subject {
        id
        variants {
          level {
            id
            label
            type
          }
        }
      }
    }
  }
`;
